import React from 'react';
import './MenuAsidebar.css';
import { Link,useMatch,useResolvedPath } from 'react-router-dom';
import { createUseStyles } from 'react-jss';

const CustomLink = ({children,to,...props}) =>{
    let resolved = useResolvedPath(to);
    let match = useMatch({path: resolved.pathname,end:true});

    return(
        <li className={`ws-asidebar-body-list-item ${match ? 'active' : ''}`}>
            <Link
                className={`ps-3 pe-3 ${match ? 'active' : ''}`}
                to={to}
                {...props}
            >
            {children}
            </Link>
        </li>
    )
}

const styles = createUseStyles( theme => ({
    asidebar : {
        backgroundColor: theme.colorPrimary
    }
}) );

export const MenuAsidebar = () => {

    const classes = styles();

    return (
        <ul className="ws-asidebar-body-list mb-0 pb-3">
            <CustomLink to="/directorio" >
                <i className="bi bi-clipboard-check pe-2"></i> Directorio
            </CustomLink>
            <CustomLink to="/nube">
                <i className="bi bi-cloud-check pe-2"></i> Nube
            </CustomLink>
            <CustomLink to="/productividad">
                <i className="bi bi-clock-history pe-2"></i> Productividad
            </CustomLink>
            <CustomLink to="/actividad">
                <i className="bi bi-activity pe-2"></i> Actividad
            </CustomLink>
            <p className="mb-0 p-3 pt-1 pb-1 ws-asidebar-category-title mt-1 ">Ajustes</p>
            <CustomLink to="/configuracion">
                <i className="bi bi-tools pe-2"></i> Configuración
            </CustomLink>
        </ul>
    )
}
